// Google Sheets Configuration
// Replace 'YOUR_GOOGLE_SHEET_ID' with your actual Google Sheet ID

export const SHEETS_CONFIG = {
  // Your Google Sheet ID - extracted from your URL
  GOOGLE_SHEET_ID: '1rCY-qVrj1K4_x6NfOcv0W1uiPrw_Nw0pRwHzz779RBQ',
  
  // Sheet range to read data from
  // Adjust based on your sheet structure
  SHEET_RANGE: 'Sheet1!A:G',
  
  // Sheet must be publicly accessible for this method to work
  // Go to File > Share > Anyone with the link can view
  IS_PUBLIC: true
};

// Instructions:
// 1. Open your Google Sheet
// 2. Click "Share" button (top right)
// 3. Click "Change to anyone with the link"
// 4. Set permission to "Viewer"
// 5. Copy the sheet ID from the URL and paste it above
// 6. Make sure your sheet has headers in the first row:
//    id, title, message, emoji, scheduledDate, show24HoursBefore, active

export default SHEETS_CONFIG;